import React, { useState } from 'react'
import { Alert, Row, Col } from 'shards-react'

import FormReset from './AdmFormReset'
import AuthService from '../../../services/auth-service/AuthService'

import '../reset-password.css'

const AdmResetPassword = props => {
    const [email, setEmail] = useState('')
    const [hasError, setHasError] = useState(false)
    const [hasSuccess, setHasSuccess] = useState(false)
    const [isFetching, setIsFetching] = useState(false)

    const informations = { isFetching, hasError }
    const sendEmail = e => {
        setIsFetching(true)
        setHasError(false)
        setHasSuccess(false)
        e.preventDefault()
        AuthService.findAccount(email)
            .then(() => {
                setIsFetching(false)
                setHasError(false)
                setHasSuccess(true)
            })
            .catch(e => {
                console.log(e)
                setIsFetching(false)
                setHasError(true)
                setHasSuccess(false)
            })
    }
    return (
        <div id="reset-password--container">
            <Row>
                <Col sm="12">
                    {hasError && (
                        <Alert theme="danger">
                            Não foi possível enviar o link para redefinição de senha. Por favor, verifique se o email
                            informado está correto.
                        </Alert>
                    )}
                    {hasSuccess && (
                        <Alert theme="success">
                            O link para redefinição de senha foi enviado com sucesso. Por favor, verifique sua caixa de
                            email.
                        </Alert>
                    )}
                </Col>
            </Row>
            <FormReset
                sendEmail={sendEmail}
                email={props.email}
                setEmail={setEmail}
                showBrand={false}
                informations={informations}
                message={'Enviando...'}
            />
        </div>
    )
}

export default AdmResetPassword
